import {
  CUSTOMER_PROFILE_REQUEST,
  CUSTOMER_PROFILE_SUCCESS,
  CUSTOMER_PROFILE_FAILURE,
  CUSTOMER_PROFILE_RESET,
} from '../actions/customerProfile'

const INITIAL_STATE = {
  loading: false,
  data: null,
  error: null,
}

const customerProfileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CUSTOMER_PROFILE_REQUEST:
      return { ...state, loading: true, error: null }
    case CUSTOMER_PROFILE_SUCCESS:
      return { ...state, loading: false, data: action.response }
    case CUSTOMER_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.error }
    case CUSTOMER_PROFILE_RESET:
      return INITIAL_STATE
    default:
      return state
  }
}

export default customerProfileReducer
